import { ListItemButton } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";

/* eslint-disable quote-props */
export const CardVisitStyle = (theme: Theme) => ({
  borderRadius: "8px",
  border: "1px solid transparent",
  boxShadow: "none",
  overflow: "hidden",
  marginBottom: "16px !important",
  transition: ".3s all",
  padding: "0 16px",
  ".pet-name": {
    fontWeight: "600",
    transform: "translateY(5px)",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0",
  },
  ".MuiAccordionSummary-content.Mui-expanded": {
    ".MuiBox-root": {
      alignItems: "center",
    },
    ".pet-name": {
      fontSize: "32px",
      fontWeight: "300",
      fontFamily: "grenette-light-pro",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "0",
      ".avatar, .pet-name": {
        display: "none !important",
      },
      ".clickeable": {
        padding: 0,
      },
    },
  },
  ".MuiAccordionDetails-root .MuiList-root .MuiButtonBase-root": {
    "svg, img": {
      marginRight: "1.5rem",
    },
  },
  "&.past": {
    borderRadius: "8px",
    boxShadow: "none",
    border: "1px solid transparent",
    background: "none",
    "&.Mui-expanded": {
      background: "#F4EFEB",
      boxShadow: "0px 4px 4px rgba(214, 199, 186, 0.25)",
    },
    "&:hover": {
      transition: ".3s all",
      background: "#F4EFEB",
    },
  },
  ".mobile-banner": {
    position: "relative",
    width: "100%",
    top: 0,
    left: 0,
    paddingBottom: "4.5rem",
    ".background": {
      width: "100%",
      aspectRatio: "16 / 9",
      objectFit: "cover",
    },
    ".background + .MuiBox-root": {
      position: "absolute",
      left: "50%",
      bottom: "17px",
      transform: "translate(-50%, -50%)",
      padding: "0",
      border: "2px solid #FFFFFF",
      borderRadius: "200px",
    },
    "h4": {
      textAlign: "center",
      transform: "translateY(3.5rem)",
      fontFamily: "grenette-light-pro",
      fontSize: "40px",
    },
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  ".icons": {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    "svg": {
      "g": {
        transform: "scale(1.2)",
        transformOrigin: "center",
      },
    },
  },
  ".MuiDivider-root": {
    borderColor: "#f4f4f4",
  },
  "&:hover": {
    boxShadow: "0px 4px 4px rgba(214, 199, 186, 0.25)",
    "> .MuiButtonBase-root": {
      "svg": {
        "path": {
          transition: ".3s all",
          fill: "#262626",
        },
      },
    },
  },
  "&.Mui-expanded": {
    boxShadow: "0px 4px 4px rgba(214, 199, 186, 0.25)",
  },
});

export const CardVisitInnerStyle = (theme: Theme) => ({
  background: "transparent",
  display: "flex",
  width: "100%",
  alignItems: "center",
  boxShadow: "none",
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "1fr",
  },
});

export const CardAccordionSummary = (theme: Theme) => ({
  padding: 0,
  "& .MuiAccordionSummary-content": {
    display: "grid",
    margin: 0,
  },
});

export const CardVisitContentStyle = (theme: Theme) => ({
  display: "flex",
  width: "100%",
  ".main-box": {
    display: "flex",
    width: "100%",
    ".name-and-icons": {
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
      gap: "1rem ",
    },
    ".name-and-info": {
      marginRight: "auto",
    },
    ".icons": {
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
      "button": {
        paddingLeft: "none",
      },
    },
  },
  "img": {
    position: "absolute",
  },
});

export const CardVisitClickable = (theme: Theme) => ({
  p: "16px",
  width: "100%",
});

export const CardVisitInfoItem = (theme: Theme) => ({
  display: "flex",
  gap: 1.6,
  pb: 0,
  "div": {
    whiteSpace: "nowrap",
    fontSize: "16px",
  },
  [theme.breakpoints.down(1290)]: {
    display: "grid",
  },
  [theme.breakpoints.between(700, 1100)]: {
    display: "flex",
  },
});

export const ListItem = styled(ListItemButton)(() => ({
  display: "flex",
  fontSize: "14px",
  padding: "0",
  alignItems: "center",
  width: "auto",
  "svg, img": {
    marginRight: ".3rem",
  },
  "&:hover": {
    background: "none",
  },
}));

